<div>
  <!-- <select class="form-control mobile-hide my-1" [(ngModel)]="selectedEvent">
      <option [value]="item.id" *ngFor="let item of eventList;trackBy:trackByIndex;">{{item.name}}</option>
  </select> -->
  <div class="mod-header tab_bets betsheading">

      <tabset type="pills nav-fill">
          <tab id="tab1" customClass="betdata">
              <ng-template tabHeading>
                  <span class="bet-label">Matched </span>
                  <span class="bat_counter" id="cnt_row"></span>
              </ng-template>
              <div class="balance-panel-body">
                  <div class="table-responsive sports-tabel">
                      <table class="table mb-0 table-bordered">
                          <thead>
                              <tr>
                                  <th>Selection</th>
                                  <th>Odds</th>
                                  <th>Stake</th>
                                  <th>Date/Time</th>
                              </tr>
                          </thead>
                          <tbody>
                            <!-- *ngFor="let item of data.matched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;" -->
                              <tr [ngClass]="item.bet_type == 1 ? 'back' : 'lay'" *ngFor="let item of data.matched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                  <td>{{item.runner_name}} {{item.market_type}}</td>
                                  <td>{{item?.betting_type == 'F' ? roundVal(item?.average_rate_matched) :item?.average_rate_matched}}</td>
                                  <td>{{item.stake_matched | number}}</td>
                                  <td>{{(item.matched_at_format ? item.matched_at_format : item.matched_at) | date : 'dd/MM/YYYY hh:mm:ss a'}}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </tab>
          <tab customClass="betdata">
              <ng-template tabHeading>
                  <span class="bet-label">UnMatched </span>
                  <span class="bat_counter" id="cnt_row"></span>
              </ng-template>
              <div class="balance-panel-body">
                  <div class="table-responsive sports-tabel">
                      <table class="table mb-0">
                          <thead>
                              <tr class="border-bottom">
                                  <th>Selection</th>
                                  <th>Odds</th>
                                  <th>Stake</th>
                                  <th>Date/Time</th>
                              </tr>
                          </thead>
                          <tbody>
                            <!-- *ngFor="let item of data.unMatched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;" -->
                              <tr [ngClass]="item.bet_type == 1 ? 'back' : 'lay'" *ngFor="let item of data.unMatched | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                  <td>{{item.runner_name}} {{item.market_type}}</td>
                                  <td>{{item.rate | number}}</td>
                                  <td>{{item.stake_remaining | number}}</td>
                                  <td>{{(item.matched_at_format ? item.matched_at_format : item.matched_at) | date :
                                      'dd/MM/YYYY hh:mm:ss a'}}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </tab>
          <tab customClass="betdata">
              <ng-template tabHeading>
                  <span class="bet-label">Fancy </span>
                  <span class="bat_counter" id="cnt_row"></span>
              </ng-template>
              <div class="balance-panel-body">
                  <div class="table-responsive sports-tabel">
                      <table class="table mb-0">
                          <thead>
                              <tr class="border-bottom">
                                  <th>Selection</th>
                                  <th>Odds</th>
                                  <th>Stake</th>
                                  <th>Date/Time</th>
                              </tr>
                          </thead>
                          <tbody>
                            <!-- *ngFor="let item of data.fancy | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;" -->
                              <tr [ngClass]="item.bet_type == 1 ? 'back' : 'lay'" *ngFor="let item of data.fancy | filter : {'event_id-eq': selectedEvent}; trackBy:trackByIndex;">
                                <td>{{item.runner_name}} {{item.market_type}}</td>
                                <td>{{item?.betting_type == 'F' ? roundVal(item?.average_rate_matched) :item?.average_rate_matched}}</td>
                                <td>{{item.stake_matched | number}}</td>
                                <td>{{(item.matched_at_format ? item.matched_at_format : item.matched_at) | date : 'dd/MM/YYYY hh:mm:ss a'}}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </tab>
      </tabset>
  </div>

</div>